import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth/auth.service';

/**
 * Protects the tenant team page. Only customer users whose company has the
 * user_invites_enabled rollout flag may enter; everyone else goes back to
 * their dashboard. (authGuard on the parent layout already handled login.)
 */
export const teamGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.canInviteUsers()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
